// extracted by mini-css-extract-plugin
module.exports = {"checkboxArea":"UserCheckbox_checkboxArea__2Haib","blockedCheckboxArea":"UserCheckbox_blockedCheckboxArea__2ecKH"};